/* ---------------------------------------------------------------------------
   Filtrar sin cambiar de página.

   Antes, elegir un año recargaba la web entera: cabecera, pie, portada y de
   vuelta arriba. En un archivo de 3.900 piezas, donde lo normal es probar
   cuatro combinaciones seguidas, eso son cuatro viajes completos para ver la
   misma página con otras piezas. Aquí solo se repinta la biblioteca y todo lo
   demás se queda donde está.

   No inventa nada: pide la MISMA dirección del enlace, solo que pidiéndole a
   Shopify únicamente esta sección. Así el HTML que llega es exactamente el que
   se vería recargando —mismo orden, mismas cuentas, misma frase— y no hay dos
   sitios donde mantener lo mismo.

   La dirección de la barra se actualiza, así que el botón de atrás deshace
   filtro a filtro y la página se puede compartir o recargar igual.

   SIN ESTE FICHERO TODO SIGUE FUNCIONANDO: los filtros son enlaces normales y
   recargan la página como siempre. Es una mejora, no un requisito.
   --------------------------------------------------------------------------- */
(() => {
  if (window.__lvCargados && window.__lvCargados.has('lv-library-filtros')) return;
  (window.__lvCargados = window.__lvCargados || new Set()).add('lv-library-filtros');

  // Los enlaces que repintan: valores de un filtro, muestras de color, las
  // pastillas de lo que hay puesto y el «ver todo».
  const ENLACES = 'a.lv-filtro__valor, a.lv-muestra, a.lv-puesto, a.lv-filtros__limpiar';

  // Las manchas de año de la entrada también filtran, aunque vivan en otra
  // sección. Eran el único camino que seguía recargando la web entera, y es
  // justo por donde entra la mayoría.
  const ENLACES_FUERA = 'a.lv-indice__mancha';

  const biblio = () => document.querySelector('[data-lv-biblio]');
  const caja = () => biblio()?.closest('[id^="shopify-section-"]');

  // La entrada de años es OTRA sección y no viaja en la respuesta, así que se
  // esconde y se enseña desde aquí. La regla es la misma que en Liquid: con
  // algún filtro puesto no se ve, porque quien ya ha elegido quiere piezas.
  const indice = () => document.querySelector('.lv-indice')?.closest('[id^="shopify-section-"]');

  let vuelo = null;

  const pinta = async (url, empujar) => {
    const raiz = caja();
    if (!raiz) return false;

    const id = biblio().dataset.lvBiblio;
    const limpia = new URL(url, location.origin);
    limpia.hash = '';

    const pedida = new URL(limpia);
    pedida.searchParams.set('section_id', id);

    // Si llega otro clic mientras está pidiendo, manda el último: quien pulsa
    // dos filtros seguidos espera ver el segundo, no el que acabe antes.
    vuelo?.abort();
    const corte = new AbortController();
    vuelo = corte;

    raiz.setAttribute('aria-busy', 'true');
    try {
      const r = await fetch(pedida, { signal: corte.signal });
      if (!r.ok) throw new Error(r.status);
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const nueva = doc.getElementById(raiz.id) || doc.body;

      // Dónde estaba la barra de filtros antes de tocar nada. Después se la
      // devuelve ahí: es el ancla de todo esto.
      const donde = raiz.querySelector('.lv-biblio__filtros')?.getBoundingClientRect().top;

      raiz.innerHTML = nueva.innerHTML;

      // Con filtros puestos hay pastillas de «quitar»: eso dice si la entrada
      // de años tiene que estar o no, sin volver a mirar la dirección.
      const hayFiltros = !!raiz.querySelector('.lv-filtros__puestos');
      const entrada = indice();
      if (entrada) entrada.hidden = hayFiltros;

      if (empujar) history.pushState({ lvBiblio: true }, '', limpia);

      // Los corazones se vuelven a marcar y la carga al bajar se reengancha a
      // la rejilla nueva.
      document.dispatchEvent(new CustomEvent('lv:wishlist:change'));
      document.dispatchEvent(new CustomEvent('lv:biblio:repintada'));

      // La barra de filtros se queda clavada donde estaba.
      //
      // Sin esto, filtrar daba un salto feo: la entrada de años vive ENCIMA de
      // la rejilla y al filtrar se esconde, así que todo lo de abajo subía de
      // golpe el alto de esa entrada —varios cientos de píxeles— y acababas
      // mirando un sitio de la página que no habías pedido. Lo mismo pasa al
      // revés al quitar el último filtro.
      //
      // Se mide la barra antes y después y se corrige el desplazamiento por la
      // diferencia. La página no se mueve por debajo de ti: lo que cambia son
      // las piezas.
      const barra = raiz.querySelector('.lv-biblio__filtros') || raiz;
      const ahora = barra.getBoundingClientRect().top;
      if (donde != null && Math.abs(ahora - donde) > 1) {
        window.scrollBy({ top: ahora - donde, behavior: 'instant' });
      }

      // Y si estabas bajando por la rejilla, se vuelve al principio de los
      // resultados.
      //
      // Antes esto preguntaba si la barra de filtros se veía, y nunca se
      // cumplía: la barra es PEGAJOSA, o sea que se ve siempre, pase lo que
      // pase. Asi que al filtrar desde abajo te quedabas a seis mil pixeles de
      // altura mirando la pieza treinta y tantas de una lista que acababa de
      // empezar. Parecia que te hubiera dejado en la pagina 6.
      //
      // Ahora se mira donde empieza la rejilla, que no se mueve de sitio. Solo
      // sube: si ya estabas por encima —mirando la cabecera, por ejemplo— no
      // se te arrastra hacia abajo.
      //
      // Sin animacion a proposito: son seis mil pixeles, y verlos pasar en
      // suave es marearse por nada.
      const rejillaNueva = raiz.querySelector('[data-lv-rejilla]');
      if (rejillaNueva) {
        const pegada = parseFloat(getComputedStyle(barra).top) || 0;
        const destino =
          rejillaNueva.getBoundingClientRect().top +
          window.scrollY -
          barra.getBoundingClientRect().height -
          pegada -
          16;
        if (window.scrollY > destino) {
          window.scrollTo({ top: Math.max(destino, 0), behavior: 'instant' });
        }
      }
      return true;
    } catch (e) {
      if (e.name === 'AbortError') return false;
      // Si algo falla, el enlace hace lo de siempre.
      location.href = url;
      return false;
    } finally {
      if (vuelo === corte) {
        vuelo = null;
        // Se quita en el fotograma siguiente, no ahora: las piezas nuevas
        // entran apagadas y suben solas. Quitándolo en el mismo instante en
        // que se insertan, el navegador no tiene dos estados que encadenar y
        // el cambio es un corte seco.
        requestAnimationFrame(() => requestAnimationFrame(() => {
          raiz.removeAttribute('aria-busy');
        }));
      }
    }
  };

  document.addEventListener('click', (e) => {
    // Un clic con ctrl, cmd o la rueda abre en otra pestaña: eso es cosa del
    // navegador y no se toca.
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest(ENLACES + ', ' + ENLACES_FUERA);
    if (!a) return;
    if (!a.matches(ENLACES_FUERA) && !caja()?.contains(a)) return;
    if (!caja()) return;
    e.preventDefault();
    pinta(a.href, true);
  });

  // El botón de atrás deshace filtro a filtro.
  window.addEventListener('popstate', () => {
    if (caja()) pinta(location.href, false);
  });
})();
